import React from "react";
import {timeago} from "./../../utils/dates";
import EPCLink from './../../component/Asset/EPCLink';
import {Link} from "react-router-dom";
import TransactionStatus from "../../transaction/component/TransactionStatus";
import moment from "moment";

class DashboardGrid {

  title = 'Dashboard';

  columns = [
    {
      Header: "Transação",
      accessor: "id",
      Cell: row => <Link
          to={"/transactions/" + row.original.transactionId}>{row.original.transactionId}</Link>
    },
    {
      Header: "EPC",
      accessor: "epc",
      Cell: row => <EPCLink epc={row.original.epc}/>
    },
    {
      Header: "Local",
      accessor: "lsd.bizLocation.friendlyName",
      Cell: row => row.original.lsd && row.original.lsd.bizLocation && row.original.lsd.bizLocation.friendlyName
    },
    {
      Header: "Referência",
      accessor: "asset.productType.reference",
      Cell: row => row.original.asset && row.original.asset.productType && row.original.asset.productType.reference
    },
    {
      Header: "Produto",
      accessor: "asset.productType.friendlyName",
      Cell: row => row.original.asset && row.original.asset.productType && row.original.asset.productType.friendlyName
    },
    {
      Header: "Data",
      accessor: "readDate",
      Cell: row => timeago(row.original.readDate)
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: row => (<TransactionStatus status={row.original.status}/>)
    }
  ];

  endpoint = `ton/v1/transactions/items?dateBegin=${moment().subtract(6, "days").toISOString()}`;

}

export default DashboardGrid;



// WEBPACK FOOTER //
// ./src/pages/Dashborad/DashboardGrid.js